import { render, staticRenderFns } from "./CreditDestinationSetting.vue?vue&type=template&id=67a86401&scoped=true"
import script from "./CreditDestinationSetting.vue?vue&type=script&lang=js"
export * from "./CreditDestinationSetting.vue?vue&type=script&lang=js"
import style0 from "./CreditDestinationSetting.vue?vue&type=style&index=0&id=67a86401&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a86401",
  null
  
)

export default component.exports